import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Address } from "../../models/address";
import { DataProvider } from "../data/data";

@Injectable()
export class AddressProviderMock {
    constructor(){
    }

    async getAddresses(): Promise<Array<Address>>{
        return new Array<Address>();
    }

    async updateAddresses(addresses: Array<Address>){
        return;
    }
}


// WEBPACK FOOTER //
// ./src/providers/address/address-mock.ts